import AddressCollectionWrapper from 'features/signup/Address/AddressCollectionWrapper';
import React from 'react';

export default function Page() {
  return <AddressCollectionWrapper />;
}
